module.exports = __webpack_public_path__ + "img/1060344-test.0c221816.png";